export default {
  lookups: state => state.lookups,
  lookupsZeus: state => state.lookupsZeus,
  groups: state => state.groups,
  timeZones: state => state.timeZones,
  insuranceCompanies: state => state.insuranceCompanies,
  vehicleMakes: state => state.vehicleMakes,
  odometerunits: state => state.odometerunits,
  damagepositions: state => state.damagepositions,
  isStaticDataLoaded: state => state.staticDataLoaded
}
